"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Slider_1 = require("../../../components/Slider");
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
var CJFormContext_1 = require("../CJFormContext");
var util_1 = require("../util");
var SliderInput = function (props) {
  var _a = (0, react_1.useContext)(CJFormContext_1.CJFormContext),
    control = _a.control,
    formState = _a.formState;
  var _b = __read((0, util_1.extractRegister)(props), 2),
    _c = _b[0],
    registerProps = _b[1],
    name = _c.name,
    className = _c.className,
    restProps = __rest(_c, ["name", "className"]);
  var defaultValue = formState.defaultValues ? formState.defaultValues[name] : undefined;
  var max = Number(getValueFromValidationRule(registerProps.max)) || undefined;
  var min = Number(getValueFromValidationRule(registerProps.min)) || undefined;
  return (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, {
    name: name,
    control: control,
    rules: registerProps,
    render: function (_a) {
      var _b;
      var field = _a.field;
      return (0, jsx_runtime_1.jsx)(Slider_1.Slider, __assign({}, restProps, {
        disabled: registerProps.disabled,
        min: min,
        max: max,
        inputError: !!formState.errors[name],
        value: (_b = field.value) !== null && _b !== void 0 ? _b : defaultValue,
        onChange: function (val) {
          field.onChange(val);
          field.onBlur();
        }
      }));
    }
  });
};
exports.SliderInput = SliderInput;
var getValueFromValidationRule = function (rule) {
  if (typeof rule === "number" || typeof rule === "string") {
    return Number(rule);
  }
  if (rule !== undefined) {
    return Number(rule.value);
  }
  return undefined;
};